import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Wrap any route that requires login. If the user isn't authenticated,
// redirect to /login with a return path so post-login we send them back.

export function RequireAuth({
  children,
  adminOnly = false,
}: {
  children: ReactElement;
  adminOnly?: boolean;
}) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-forest/60 italic">
        Checking your session…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  if (adminOnly && user.role !== 'admin') {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24">
        <h1 className="text-3xl font-display text-forest mb-3">Admin only</h1>
        <p className="text-forest/70">
          Your account doesn't have admin access. If this is a mistake, reach out to the team.
        </p>
      </div>
    );
  }

  return children;
}
